import { apiPatch } from '../../../_shared/utils/api/api.helpers';

export const userDataSettingsUpdateSetting = (patches: string[]) => {
  const requestUrl = '/api/user/settings';

  return apiPatch(requestUrl, { data: patches });
};
